<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 card_bg">
					<search-container ref="mdjDataSearch" :scrId="scrId"></search-container>
				</sf-card>
			</div> 
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-container
						ref="tableContainer"
						@Refresh="Refresh"
						@excelUpOpen="excelUpOpen"
						:scrId="scrId"
					></table-container>
					<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" />  
				</sf-card>
			</div> 
			
			<!--엑셀 업로드 팝업창 영역 끝-->
			
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../store/helpers';
import SearchContainer from './Search/SearchContainer.vue';
import TableContainer from './Table/TableContainer.vue';
import ExcelUploadModal from './popup/ExcelUpload.vue'; //엑셀업로드 모달창
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			sendParam: {},
			faivorite: true,
			screen: {},
			sendParam3: {} //원인부품팝업
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	components: {
		SearchContainer,
		TableContainer,
		ExcelUploadModal
	},
	methods: {
		...serviceMethods,
		excelUpOpen(param) {
			this.$refs.excelUploadPop.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		},
		Refresh() {
			this.$sf_toggleLoading(false);
			this.$refs.mdjDataSearch.searchList();
		}
	},
	created() {
		//this.$sf_toggleLoading(true);
		//this.getCommCodes_({ key: 'opCdList', codeType: 'OP_CD' }); //OP코드
		//this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' }); //PWA 여부
		//this.$sf_toggleLoading(false);
	}
};
</script>

<style></style>
